'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { AnimatePresence, motion } from 'motion/react';
import { type ReactNode, useEffect, useState } from 'react';
interface TextFlipProps {
  words: ReactNode[];
  duration?: number;
  className?: string;
}
function TextFlip(t0) {
  const $ = _c(19);
  const {
    words: t1,
    duration: t2,
    className
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const words = t3;
  const duration = t2 === undefined ? 3000 : t2;
  const [currentIndex, setCurrentIndex] = useState(0);
  let t4;
  let t5;
  if ($[2] !== duration || $[3] !== words.length) {
    t4 = () => {
      const interval = setInterval(() => {
        setCurrentIndex(prevIndex => (prevIndex + 1) % words.length);
      }, duration);
      return () => {
        clearInterval(interval);
      };
    };
    t5 = [duration, words.length];
    $[2] = duration;
    $[3] = words.length;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== className) {
    t6 = cn("relative w-fit overflow-hidden rounded-md", className);
    $[6] = className;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t10;
  let t11;
  let t7;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      y: -40,
      filter: "blur(10px)"
    };
    t8 = {
      y: 0,
      filter: "blur(0px)"
    };
    t9 = {
      y: 50,
      filter: "blur(10px)",
      opacity: 0
    };
    t10 = {
      duration: 0.5
    };
    t11 = cn("inline-block whitespace-nowrap");
    $[8] = t10;
    $[9] = t11;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[8];
    t11 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  const t12 = words[currentIndex];
  let t13;
  if ($[13] !== currentIndex || $[14] !== t12) {
    t13 = <AnimatePresence mode="popLayout"><motion.span key={currentIndex} initial={t7} animate={t8} exit={t9} transition={t10} className={t11}>{t12}</motion.span></AnimatePresence>;
    $[13] = currentIndex;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t13 || $[17] !== t6) {
    t14 = <motion.span layout={true} className={t6}>{t13}</motion.span>;
    $[16] = t13;
    $[17] = t6;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  return t14;
}
export { TextFlip };